import Term from "./terms";
import {CloneReducer} from "shift-reducer";
export default class ParseReducer extends CloneReducer {
  reduceModule(node_415, state_416) {
    return new Term("Module", {directives: state_416.directives.toArray(), items: state_416.items.toArray()});
  }
  reduceImport(node_417, state_418) {
    let moduleSpecifier_419 = state_418.moduleSpecifier ? state_418.moduleSpecifier.val() : null;
    return new Term("Import", {defaultBinding: state_418.defaultBinding, namedImports: state_418.namedImports.toArray(), moduleSpecifier: moduleSpecifier_419, forSyntax: node_417.forSyntax});
  }
  reduceImportNamespace(node_420, state_421) {
    let moduleSpecifier_422 = state_421.moduleSpecifier ? state_421.moduleSpecifier.val() : null;
    return new Term("ImportNamespace", {defaultBinding: state_421.defaultBinding, namespaceBinding: state_421.namespaceBinding, moduleSpecifier: moduleSpecifier_422, forSyntax: node_420.forSyntax});
  }
  reduceExport(node_423, state_424) {
    return new Term("Export", {declaration: state_424.declaration});
  }
  reduceExportAllFrom(node_425, state_426) {
    let moduleSpecifier_427 = state_426.moduleSpecifier ? state_426.moduleSpecifier.val() : null;
    return new Term("ExportAllFrom", {moduleSpecifier: moduleSpecifier_427});
  }
  reduceExportFrom(node_428, state_429) {
    let moduleSpecifier_430 = state_429.moduleSpecifier ? state_429.moduleSpecifier.val() : null;
    return new Term("ExportFrom", {moduleSpecifier: moduleSpecifier_430, namedExports: state_429.namedExports.toArray()});
  }
  reduceExportSpecifier(node_431, state_432) {
    let name_433 = state_432.name, exportedName_434 = state_432.exportedName;
    if (name_433 == null) {
      name_433 = exportedName_434.resolve();
      exportedName_434 = exportedName_434.val();
    } else {
      name_433 = name_433.resolve();
      exportedName_434 = exportedName_434.val();
    }
    return new Term("ExportSpecifier", {name: name_433, exportedName: exportedName_434});
  }
  reduceImportSpecifier(node_435, state_436) {
    let name_437 = state_436.name ? state_436.name.resolve() : null;
    return new Term("ImportSpecifier", {name: name_437, binding: state_436.binding});
  }
  reduceIdentifierExpression(node_438, state_439) {
    return new Term("IdentifierExpression", {name: node_438.name.resolve()});
  }
  reduceLiteralNumericExpression(node_440, state_441) {
    return new Term("LiteralNumericExpression", {value: node_440.value.val()});
  }
  reduceLiteralBooleanExpression(node_442, state_443) {
    return new Term("LiteralBooleanExpression", {value: node_442.value.val() === "true"});
  }
  reduceLiteralStringExpression(node_444, state_445) {
    return new Term("LiteralStringExpression", {value: node_444.value.token.str});
  }
  reduceCallExpression(node_446, state_447) {
    return new Term("CallExpression", {callee: state_447.callee, arguments: state_447.arguments.toArray()});
  }
  reduceFunctionBody(node_448, state_449) {
    return new Term("FunctionBody", {directives: state_449.directives.toArray(), statements: state_449.statements.toArray()});
  }
  reduceFormalParameters(node_450, state_451) {
    return new Term("FormalParameters", {items: state_451.items.toArray(), rest: state_451.rest});
  }
  reduceBindingIdentifier(node_452, state_453) {
    return new Term("BindingIdentifier", {name: node_452.name.resolve()});
  }
  reduceBinaryExpression(node_454, state_455) {
    return new Term("BinaryExpression", {left: state_455.left, operator: node_454.operator.val(), right: state_455.right});
  }
  reduceObjectExpression(node_456, state_457) {
    return new Term("ObjectExpression", {properties: state_457.properties.toArray()});
  }
  reduceVariableDeclaration(node_458, state_459) {
    return new Term("VariableDeclaration", {kind: state_459.kind, declarators: state_459.declarators.toArray()});
  }
  reduceStaticPropertyName(node_460, state_461) {
    return new Term("StaticPropertyName", {value: node_460.value.val().toString()});
  }
  reduceArrayExpression(node_462, state_463) {
    return new Term("ArrayExpression", {elements: state_463.elements.toArray()});
  }
  reduceStaticMemberExpression(node_464, state_465) {
    return new Term("StaticMemberExpression", {object: state_465.object, property: state_465.property.val()});
  }
}
